/**
 * holy-drawer-brand-moment.js · 2026-06-06 (r2 — sticky-bottom Map Your Skin)
 *
 * Renders a Renewal-Arc lead-in + Map Your Skin CTA pinned to the drawer's
 * bottom edge as the user scrolls the menu. Earlier brand-moment block
 * (Ø + HØLY wordmark + "Your body is a temple" tagline) is retired in favor
 * of a single recognition→invitation beat.
 *
 * Wonder's <aside class="wt-page-nav-mega__aside"> remains hidden via CSS.
 * Stickiness handled by `position: sticky; bottom: 0` in custom.css.
 */
(() => {
  'use strict';

  const MARKER = 'holy-drawer-brand-moment';
  const MAP_URL = '/pages/find-your-arc';
  const LEAD_LINES = ['Renewal is a sequence.', 'Find yours.'];

  function buildBrandMoment() {
    const root = document.createElement('div');
    root.className = MARKER;
    root.setAttribute('data-holy-drawer-brand-moment', '');

    const lead = document.createElement('p');
    lead.className = MARKER + '__lead';
    LEAD_LINES.forEach((line, i) => {
      if (i > 0) lead.appendChild(document.createElement('br'));
      lead.appendChild(document.createTextNode(line));
    });

    const cta = document.createElement('a');
    cta.className = MARKER + '__cta';
    cta.href = MAP_URL;
    cta.textContent = 'Map Your Skin';
    const arrow = document.createElement('span');
    arrow.className = MARKER + '__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = ' →';
    cta.appendChild(arrow);

    root.appendChild(lead);
    root.appendChild(cta);

    return root;
  }

  function inject() {
    // Wonder uses .wt-drawer--nav (desktop drawer) and .wt-drawer--mobile-nav
    // (mobile drawer) — target both.
    const drawerInners = document.querySelectorAll(
      '.wt-drawer--nav mega-menu-section, .wt-drawer--mobile-nav mega-menu-section'
    );
    drawerInners.forEach((container) => {
      if (container.querySelector('.' + MARKER)) return;
      container.appendChild(buildBrandMoment());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  // Drawer rendering is sometimes deferred — watch for late mount. We only
  // observe a narrow set of mutations (childList on body) to avoid the
  // perf trap that bit the waitlist intercept earlier today.
  let injectTimer = null;
  const scheduleInject = () => {
    if (injectTimer) return;
    injectTimer = setTimeout(() => { injectTimer = null; inject(); }, 250);
  };
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length === 0) continue;
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('.wt-drawer--nav, .wt-drawer--mobile-nav') ||
            node.querySelector?.('.wt-drawer--nav, .wt-drawer--mobile-nav')) {
          scheduleInject();
          return;
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: false });
})();
